import React from "react"
import { useNavigate } from "react-router-dom"
import Box from "@mui/material/Box"
import Container from "@mui/material/Container"
import Typography from "@mui/material/Typography"
import Link from "@mui/material/Link"
import bmbfLogo from "../img/bmbf/bmbf.png"
import { F_START_AGB, F_START_DATENSCHUTZ, F_START_IMPRESSUM } from "../../../constants/routes"

const Footer = () => {
  const navigate = useNavigate()

  return (
    <Box component="footer" sx={{ bgcolor: "background.paper", py: 6 }}>
      <Container maxWidth="lg">
        <img
          alt="BMBF"
          src={bmbfLogo}
          style={{
            display: "block",
            margin: "0 auto",
            height: "150px",
          }}
        />
        <Typography variant="h6" align="center" gutterBottom>
          Bookay {new Date().getFullYear()}
        </Typography>
        <Typography variant="subtitle1" align="center" component="p">
          <Link href="#" sx={{ textDecoration: "none" }} color="text.secondary" onClick={() => navigate(F_START_IMPRESSUM)}>
            Impressum |{" "}
          </Link>
          <Link href="#" sx={{ textDecoration: "none" }} color="text.secondary" onClick={() => navigate(F_START_DATENSCHUTZ)}>
            {" "}
            Datenschutzerklärung |{" "}
          </Link>
          <Link href="#" sx={{ textDecoration: "none" }} color="text.secondary" onClick={() => navigate(F_START_AGB)}>
            AGB
          </Link>
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          {"Copyright © "}
          <Link color="inherit" href="#" onClick={() => navigate(F_START_IMPRESSUM)}>
            Dmitrij Tjumenzew
          </Link>{" "}
          {new Date().getFullYear()}
          {"."}
        </Typography>
      </Container>
    </Box>
  )
}

export default Footer
